import { formatMonto, totalesPorMoneda } from "../utils/formato";

/**
 * Barra de arriba de cada bandeja: buscador + cantidad de filas + total de
 * monto. Se comparte para que las 5 páginas se vean y se usen igual.
 *
 * El total va SIEMPRE agrupado por moneda — sumar UYU con USD daría un número
 * inventado (ver totalesPorMoneda en utils/formato.ts).
 */
interface Props {
  busqueda: string;
  onBuscar: (valor: string) => void;
  /** Filas que pasan el filtro (sin paginar) — sobre estas se calcula el total. */
  filtradas: Array<{ monto: string | number | null; moneda: string | null }>;
  /** Total sin filtrar, para poder decir "12 de 63" cuando hay búsqueda activa. */
  totalSinFiltro: number;
  /** Se oculta el total de monto donde no aporta (ej. Fuera de Carril A). */
  mostrarTotal?: boolean;
  placeholder?: string;
}

export function TablaToolbar({
  busqueda,
  onBuscar,
  filtradas,
  totalSinFiltro,
  mostrarTotal = true,
  placeholder = "Buscar por proveedor, RUT o numero de CFE...",
}: Props) {
  const totales = totalesPorMoneda(filtradas);
  const hayFiltro = busqueda.trim().length > 0;

  return (
    <div className="tabla-toolbar">
      <input
        type="search"
        className="buscador"
        value={busqueda}
        placeholder={placeholder}
        onChange={(e) => onBuscar(e.target.value)}
      />

      <div className="tabla-toolbar-info">
        <span className="conteo-filas">
          {hayFiltro ? (
            <>
              <b>{filtradas.length}</b> de {totalSinFiltro}
            </>
          ) : (
            <>
              <b>{totalSinFiltro}</b> {totalSinFiltro === 1 ? "factura" : "facturas"}
            </>
          )}
        </span>

        {mostrarTotal && totales.length > 0 && (
          <span className="totales-monto">
            {totales.map(({ moneda, total }) => (
              <span key={moneda} className="total-moneda">
                {moneda} <b className="mono">{formatMonto(total)}</b>
              </span>
            ))}
          </span>
        )}
      </div>
    </div>
  );
}
